import request from 'api/requestUtils'
import { getCookies } from 'lib/web/cookieUtils'

export type CartItemResponse = {
  items: App.Checkout.Item[]
  total: number | undefined
}

function extractDomainUserIdCookie(): string | undefined {
  const snowplowCookieValue = Object.entries(getCookies()).find((entry: Array<string>) => entry[0].startsWith('_sp_id.'))
  if (snowplowCookieValue) {
    const splitSnowplowDomainUserId = snowplowCookieValue[1].split('.')
    return splitSnowplowDomainUserId ? splitSnowplowDomainUserId[0] : undefined
  }
}

export function putCart(transactionKey, cart) {
  return request.put(`/api/carts/${transactionKey}`, { ...cart, domainUserId: extractDomainUserIdCookie() }, { credentials: 'include' })
}

export function finalizeCart(transactionKey) {
  return request.patch(`/api/carts/${transactionKey}`, { op: 'finalize' }, { credentials: 'include' })
}

export function putNewCheckoutCart(transactionKey, cart) {
  return request.put(`/api/carts/v2/${transactionKey}`, { ...cart, domainUserId: extractDomainUserIdCookie() }, { credentials: 'include' })
}

export function getCartItems(cartId): Promise<CartItemResponse> {
  return request.get<CartItemResponse>(`/api/carts/v2/${cartId}/items`, { credentials: 'include' }).then((res) => ({ items: res.items, total: res.total }))
}
